<template>
	<div
		class="modal"
		:class="[`modal--${modalType}`, { 'modal--active': modalActive }]"
	>
		<div v-if="settings.showBackground" class="modal__background"></div>
		<div class="modal__content" v-html="modalContent"></div>
		<button
			v-if="modalButton"
			class="btn btn--active"
			@click="modalButton.function"
		>
			{{ modalButton.text }}
		</button>
	</div>
</template>

<script>
export default {
	computed: {
		modalType() {
			return this.$store.state.modal.type
		},
		modalActive() {
			return this.$store.state.modal.active
		},
		modalContent() {
			return this.$store.state.modal.content
		},
		settings() {
			return this.$store.state.modal.settings
		},
		modalButton() {
			if (this.$store.state.modal.button.text)
				return this.$store.state.modal.button
			else return false
		},
	},
}
</script>

<style lang="scss">
@import 'henris';
$base-transition: 0.2s;
.modal {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	z-index: 10;
	pointer-events: none;
	&__background {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		opacity: 0;
		top: 0;
		background-color: black;
		transition: opacity $base-transition $base-cubic-bezier;
	}
	&__content {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%) scale(var(--scale, 0))
			rotate(var(--rotation, 0deg));
		padding: grid(1);
		background-color: color(_White);
		transition: transform $base-transition $base-transition
			$base-cubic-bezier;
	}
	&--clickable {
		.modal__content {
			pointer-events: all;
		}
	}
	&--active {
		.modal__background {
			opacity: 0.5;
			transition: transform $base-transition $base-cubic-bezier;
		}
		.modal__content {
			--scale: 1;
			transition: transform $base-transition $base-transition
				$base-cubic-bezier;
		}
	}
}
</style>
